// extracted by mini-css-extract-plugin
module.exports = {"header":"zfdZnmzU_yb_e91KCRTA","primaryHeader":"E5LnlOSCowpG3Vh0xL9J","actionsHeader":"sVu4T8s93r4rUlig095w","message":"z8WVMEOuBInaccjGmNmr"};